"use client";
import { useClientTranslation } from "@rimo/frontend/hooks/i18n/useClientTranslation";

import React from "react";
import styled from "styled-components";
import type { RequestMaterialProps } from "../../components/landing/voice/RequestMaterialForm";
import { RequestMaterialForm } from "../../components/landing/voice/RequestMaterialForm";
import { Header } from "../genericLP/Header";
import { MOBILE_BREAKPOINT } from "../genericLP/shared";
import { Header1 } from "@rimo/ui-old";

export const OverviewDoc: React.FC<RequestMaterialProps> = (props) => {
  const { customT } = useClientTranslation();
  return (
    <Container>
      <Header target="proceedings" />
      <Main>
        <LeftBlock>
          <Header1>{customT("資料ダウンロード")}</Header1>
          <Image src="/assets/form/serviceMaterial.jpg" alt={customT("サービス概要資料")} width={840} height={630} />
        </LeftBlock>
        <RightBlock>
          <RequestMaterialForm {...props} />
        </RightBlock>
      </Main>
    </Container>
  );
};

const Container = styled.div``;
const Main = styled.div`
  @media (min-width: ${`${MOBILE_BREAKPOINT}px`}) {
    display: flex;
    padding: 64px 48px;
    justify-content: center;
  }
`;
const RightBlock = styled.div`
  width: 100%;
`;
const LeftBlock = styled.div`
  margin-top: 70px;
  padding: 0 24px;
`;
const Image = styled.img`
  max-width: 520px;
  margin-top: 24px;

  @media (max-width: ${`${MOBILE_BREAKPOINT + 1}px`}) {
    max-width: 100%;
  }
`;
